// removed by extract-text-webpack-plugin
module.exports = {"events":"_3n6cY","pitch":"_3qt3W","about":"_1X6GW","link":"_283e2"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/index.sass
// module id = ./src/pages/Home/index.sass
// module chunks = 6